module.exports = __webpack_public_path__ + "img/spain-digestive-diseases-male.da354951.png";